import { LOGIN, PROVIDER_AUTH, SIGN_IN, SIGN_UP } from './routes'

export const GoogleDriveScope = 'https://www.googleapis.com/auth/drive'
export const GoogleSpreadsheetScope = 'https://www.googleapis.com/auth/spreadsheets'

export const OAUTH_BASIC_USER_PROFILE_SCOPES = 'openid email profile'
export const oauthScope = (
    'openid ' +
    'https://www.googleapis.com/auth/userinfo.email ' +
    'https://www.googleapis.com/auth/userinfo.profile ' +
    'https://www.googleapis.com/auth/drive ' +
    'https://www.googleapis.com/auth/spreadsheets'
)

export const GIS_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount'
export const GIS_OAUTH_ERRORS = ['access_denied', 'popup_closed', 'popup_failed_to_open']
/**
 * Scopes that are considered essential and the application may not work properly without them.
 */
export const OAUTH_ESSENTIAL_APP_SCOPES = [GoogleDriveScope, GoogleSpreadsheetScope]

export const GIS_IDENTIFIABLE_URL_PARAMS = ['code', 'access_token', 'error', 'magicToken']
export const GIS_COMMON_URL_PARAMS = [
    'code', 'access_token', 'scope', 'error', 'state', 'hd',
    'authuser', 'prompt', 'session_state', 'magicToken'
]
export const NON_REDIRECT_ENTRY_PAGES = ['login', 'sign-in', 'provider-auth']
export const NON_VALID_ENTRY_PATHS = [LOGIN, SIGN_IN, SIGN_UP, PROVIDER_AUTH]
export const FORCED_REDIRECT_AFTER_SIGN_UP_TIMEOUT = 5000
export const LAST_CLICKED_PROVIDER_STORAGE_KEY = 'LAST_CLICKED_PROVIDER'

export const BigQueryReadOnlyScope = 'https://www.googleapis.com/auth/bigquery.readonly'
export const BigQueryScope = 'https://www.googleapis.com/auth/bigquery'
export const GoogleDocsScope = 'https://www.googleapis.com/auth/documents'
export const GmailScope = 'https://www.googleapis.com/auth/gmail.send'
export const GmailComposeScope = 'https://www.googleapis.com/auth/gmail.compose'

/**
 * OAuth scope including all available Google services.
 * Used when full_scopes=true query param is present on sign-in.
 */
export const oauthFullScope = [
    oauthScope,
    GoogleDocsScope,
    GmailScope,
    BigQueryReadOnlyScope
].join(' ')

export const POSSIBLE_ADDITIONAL_SCOPES = [
    BigQueryReadOnlyScope,
    GoogleDocsScope,
    BigQueryScope,
    GmailScope
]

export const NonExclusiveScopes = {
    [GmailScope]: [GmailScope, GmailComposeScope]
}

// These users won't be affected by lockable inside the app
// "@sheetgo.com" users are already unaffected
export const NonLockableUsers = [
    'user-sheetgo-210@gedu-demo-sheetgo.com',
    'user-sheetgo-211@gedu-demo-sheetgo.com',
    'user-sheetgo-212@gedu-demo-sheetgo.com',
    'user-sheetgo-213@gedu-demo-sheetgo.com',
    'user-sheetgo-214@gedu-demo-sheetgo.com'
]

// When in the process of OAuth verification request, we need to use the official Google sign-in button
// https://developers.google.com/identity/branding-guidelines
export const useGoogleSignInBranding = false

export const PublicEmailDomains = [
    'gmail',
    'outlook',
    'hotmail',
    'msn',
    'live',
    'passport',
    'yahoo',
    'icloud',
    'mail',
    'inbox',
    'aol',
    'zoho',
    'yandex'
]

export const AuthClientVersion = {
    DEFAULT: 'default',
    ALT: 'alternative'
}

/**
 * Check if a given email is from a public domain.
 *
 * @param {string} userEmail - The user email.
 * @returns {boolean} If it's from public domain or not.
 */
export const hasPublicDomain = (userEmail) => {
    if (typeof userEmail !== 'string' || !userEmail.includes('@')) return true
    const userDomain = `@${userEmail.split('@')[1]}`
    return Boolean(PublicEmailDomains.find(pd => userDomain.includes(`@${pd}.`)))
}

/**
 * Check if a given domain is public.
 *
 * @param {string} company - The user email.
 * @returns {boolean} If it's from public domain or not.
 */
export const isPublicDomain = domain => {
    if (typeof company !== 'string') return true
    return Boolean(PublicEmailDomains.find(pd => domain.includes(`${pd}.`)))
}

/**
 * Get one of the specific colors for the sign up page avatars.
 *
 * @returns {string} A random color.
 */
export const getOauthAvatarColor = () => {
    const colors = [
        '#10A39A', '#F56BF0', '#FF73AE',
        '#FFB054', '#3AB8FF', '#A369FE'
    ]
    const randomIndex = Math.floor(Math.random() * colors.length)
    return colors[randomIndex]
}
